import React, { Component } from 'react';
import Helpers from '../helpers/Helpers';
import mutationCreateNewsletter from '../graphql/mutations/mutationCreateNewsletter.gql';
import { graphql, withApollo, compose } from 'react-apollo';
import EmailInputComponent from './EmailInputComponent';

class Newsletter extends Component {

  constructor(props) {

    super(props);

    const { titulo, is_dark_pattern } = this.props;

    this.state = {
      'title': titulo,
      'accept_newsletter': is_dark_pattern,
      'greeting_message': Helpers.getGreeting(),
      'sended': false,
      'email': '',
      'has_error': false,
      'show_suggestions': false,
      'position_left_suggestions_box': 60,
      'is_loading': false
    };

    this.handleChangeAcceptNewsletter = this.handleChangeAcceptNewsletter.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

  }

  handleChangeAcceptNewsletter() {
    this.setState({ "accept_newsletter": !this.state.accept_newsletter });
  }

  formSended() {
    this.setState({ "sended": true });
  }

  resetError() {
    this.setState({ "has_error": false });
  }

  hasError() {
    this.setState({ "has_error": true });
  }

  async handleSubmit(event) {

    event.preventDefault();

    this.setState({ "is_loading": true });
    this.resetError();

    const { email } = this.state;
    const { createNewsletter } = this.props;

    let date = new Date();

    let day = Helpers.numberLessThanTen(date.getDate(), true);
    let month = Helpers.numberLessThanTen(date.getMonth(), true);
    let year = date.getFullYear();
    let hours = Helpers.numberLessThanTen(date.getHours(), true);
    let minutes = Helpers.numberLessThanTen(date.getMinutes(), true);
    let seconds = Helpers.numberLessThanTen(date.getSeconds(), true);

    const formattedDate = `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;

    try {

      const { data } = await createNewsletter({
        variables: {
          newsletter: {
            newsletterClientName: "NDA",
            newsletterClientEmail: email,
            newsInternalPage: "_newsletter-vtex",
            newsInternalPart: "newsletter",
            newsInternalCampaign: "newsletter:opt-in"
          },
          recipients: {
            "apiPostId": 118,
            "data": [
              { "name": "DS_ORIGEM_CADASTRO", "value": "ECOM" },
              { "name": "DS_CAMPANHA", "value": "NEWSLETTER" },
              { "name": "DT_CADASTRO", "value": formattedDate },
              { "name": "DS_EMAIL", "value": email }
            ],
          }
        }
      });

      this.formSended();
      this.setState({ "is_loading": false });

    } catch (err) {
      this.hasError();
      this.setState({ "is_loading": false });
    }
  }

  render() {

    let { titulo, subtitulo, button_email_text, radio_text, success_text, input_email_text, info_text } = this.props;

    return (
      <div className="subscribe">
        <header className="subscribe__head">
          <h6>{this.state.greeting_message}!</h6>
          {!this.state.sended ? (
            <h3 dangerouslySetInnerHTML={{ __html: titulo }}></h3>
          ) : (
              <h3>{success_text}</h3>
            )}
          {!this.state.sended ? (
            <p>{subtitulo}</p>
          ) : (
              <p>{info_text}</p>
            )}
        </header>
        {!this.state.sended &&
          <div className="subscribe__body">
            <form method="post" onSubmit={this.handleSubmit}>
              <EmailInputComponent self={this} button_text={button_email_text} input_text={input_email_text} type="newsletter" />
              {this.state.has_error &&
                <div className="msg msg-error">Houve um erro, por favor tente novamente!</div>
              }
              <div className="checkbox">
                <input type="checkbox" id="subscribe" defaultValue={this.state.accept_newsletter} defaultChecked={this.state.accept_newsletter} onChange={this.handleChangeAcceptNewsletter} />
                <label htmlFor="subscribe">{radio_text}</label>
                {/* {!this.state.accept_newsletter && (
                  <span className="msg-info">Para cadastrar seu email, você deve aceitar receber e-mails com novidades e promoções de oBoticário"</span>
                )} */}
              </div>
            </form>
          </div>
        }
      </div>
    )
  }
}

Newsletter.propTypes = {
  titulo: PropTypes.string,
  subtitulo: PropTypes.string,
  input_email_text: PropTypes.string,
  button_email_text: PropTypes.string,
  radio_text: PropTypes.string,
  success_text: PropTypes.string,
  info_text: PropTypes.string,
  is_dark_pattern: PropTypes.bool
};

Newsletter.schema = {
  title: 'Newsletter',
  description: 'A simple Newsletter component',
  type: 'object',
  properties: {
    titulo: {
      type: 'string',
      title: 'Titulo'
    },
    subtitulo: {
      type: 'string',
      title: 'Sub-Titulo'
    },
    input_email_text: {
      type: 'string',
      title: 'Texto do campo de cadastro do email'
    },
    button_email_text: {
      type: 'string',
      title: 'Texto do botão de cadastro do email'
    },
    radio_text: {
      type: 'string',
      title: 'Texto de aceito receber'
    },
    success_text: {
      type: 'string',
      title: 'Texto de confirmação de cadastro'
    },
    info_text: {
      type: 'string',
      title: 'Texto de informação'
    },
    is_dark_pattern: {
      type: 'boolean',
      title: 'Gostaria de deixar o aceito receber e-mails com novidades e promoções de oBoticário, checado por padrão?',
      default: true
    }
  }
};

export default compose(
  graphql(mutationCreateNewsletter, { name: 'createNewsletter' }),
)(withApollo(Newsletter))